import { createEntitiesReducer } from 'app/lib/betting/betting-entities';
import { isSSR } from 'app/packages/components';

import {
  APPLY_PREMATCH_MATCHES,
  APPLY_STATE,
  getFullMatchContent,
  getPrematchContent,
  SUBSCRIBE, SUBSCRIBE_TO_PREMATCH_MATCHES,
  UNSUBSCRIBE, UNSUBSCRIBE_FROM_PREMATCH_MATCHES,
} from '../actions';

export const reduceGridEntities = createEntitiesReducer(isSSR ? {
  REQUEST_ACTION: getPrematchContent.pending.toString(),
  TRIGGER_ACTION: getPrematchContent.fulfilled.toString(),
  FAILURE_ACTION: getPrematchContent.rejected.toString(),
} : {
  REQUEST_ACTION: SUBSCRIBE,
  TRIGGER_ACTION: APPLY_STATE,
  CLEANUP_ACTION: UNSUBSCRIBE,
});

export const reduceMatchGridEntities = createEntitiesReducer(isSSR ? {
  REQUEST_ACTION: getFullMatchContent.pending.toString(),
  TRIGGER_ACTION: getFullMatchContent.fulfilled.toString(),
  FAILURE_ACTION: getFullMatchContent.rejected.toString(),
} : {
  REQUEST_ACTION: SUBSCRIBE_TO_PREMATCH_MATCHES,
  TRIGGER_ACTION: APPLY_PREMATCH_MATCHES,
  CLEANUP_ACTION: UNSUBSCRIBE_FROM_PREMATCH_MATCHES,
});
